import {
  OrderedListOutlined,
  RightOutlined,
  UsergroupAddOutlined,
} from "@ant-design/icons";
import { Button, Col, Divider, Row } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Statistic from "../../../components/statistic";
import { CountTotalType } from "../../../constants/dashbord";
import Requestor from "../../../requestor";
import AccountLine from "./accountLine";
import ServeLine from "./serveLine";

const DashbordPage: React.FC = () => {
  const Navigate = useNavigate();
  const [data, setData] = useState<null | CountTotalType>(null);

  const init = async () => {
    try {
      const res = await Requestor.getCountTotal<CountTotalType>();
      if (res.error !== "") {
        throw new Error(res.error);
      }
      setData(res.result);
      autoRefresh();
    } catch (e) {
      console.log(e);
    }
  };

  // 自动刷新
  let timerA: NodeJS.Timer;
  const autoRefresh = () => {
    timerA = setTimeout(() => {
      try {
        init();
      } catch (error) {
      } finally {
        clearTimeout(timerA);
      }
    }, 60000);
  };

  useEffect(() => {
    init();
    return () => {
      if (timerA) clearTimeout(timerA);
    };
  }, []);

  return (
    <div>
      <div className="flex justify-between margin-bottom-16px">
        <h3>Dashbord</h3>
        <div style={{ width: "auto" }}>
          <Button type="primary" onClick={() => Navigate("/history")}>
            服务列表
            <OrderedListOutlined />
          </Button>
          <Divider type="vertical" />
          {/* 
            <Button type="primary" onClick={() => Navigate("/dispatchers")}>
              查勘员管理
              <UsergroupAddOutlined />
            </Button>
          */}
        </div>
      </div>
      <Row gutter={16}>
        <Col span={5}>
          <Statistic
            title="调度总量"
            value={data?.serverTotal}
            suffix="单"
            onClick={() => Navigate("/history")}
          />
        </Col>
        <Col span={5}>
          <Statistic
            title="核价总量"
            value={data?.pricingTotal}
            suffix="单"
            onClick={() => Navigate("/pricing")}
          />
        </Col>
        <Col span={5}>
          <Statistic
            title="服务总金额"
            value={(data?.amountTotal || 0) / 100}
            suffix="元"
            tip="已审核"
            onClick={() => Navigate("/history")}
          />
        </Col>
        <Col span={5}>
          <Statistic
            title="已结算"
            value={(data?.settled || 0) / 100}
            suffix="元"
            tip="已审核"
            valueStyle={{ color: "#51d226" }}
            onClick={() =>
              Navigate({ pathname: "/history", search: `checkedout=1` })
            }
          />
        </Col>
        <Col span={4}>
          <Statistic
            title="未结算"
            value={(data?.notSettled || 0) / 100}
            suffix="元"
            tip="已审核"
            valueStyle={{ color: "red" }}
            onClick={() =>
              Navigate({ pathname: "/history", search: `checkedout=0` })
            }
          />
        </Col>
      </Row>
      <ServeLine />
      <AccountLine />
    </div>
  );
};

export default DashbordPage;
